module.exports = __webpack_public_path__ + "img/popup-bottom-battery-3.9dd39221.svg";